export interface Member {
  id: string;
  name: string;
  generation: number;
  university: string;
  company: string;
  role: 'member' | 'executive' | 'president' | 'vice_president';
  profile_image_url: string | null;
}

const rawData = `
이경택|1|연세대학교 정보산업공학 대학원 석/박사||member
김강진|1|서울대학교 보건통계 대학원 석/박사||member
김보섭|1|건국대학교 통계학과|NAVER Clova|member
김윤진|1|이화여자대학교 교육공학과 석사||member
김현주|1|숙명여자대학교 교육대학원 일반사회||member
이영운|2|건국대학교 통계학과|코웨이|member
박재선|2|고려대학교 산업경영공학과 대학원 석사|SKT T-Brain|member
방성수|2|고려대학교 통계 대학원 석사|KAKAO AI부문|member
서덕성|2|고려대학교 산업경영공학과 대학원 석사|한국전력공사|member
김소희|2|숙명여자대학교 통계학과|신한생명 언더라이팅팀|member
김상진|2|연세대학교 정보산업공학 대학원 석/박사||member
변성재|2|KAIST 전기 및 전자 공학부 석사|삼성전자 반도체연구소|member
여혜리|3|건국대학교 응용통계학과|SK C&C|member
김다정|3|동덕여자대학교 정보통계학과||member
문상준|3|서울시립대학교 통계 대학원 석/박사|NFTBank|member
권도영|3|숙명여자대학교 통계 대학원 석사|롯데정보통신 빅데이터팀|member
김예진|3|숙명여자대학교 통계학과|우리은행 IT팀|member
이광호|3|숭실대학교 경제학과|현대캐피탈|member
박희경|3|인하대학교 통계 대학원 석사|SK ON AI&Data|member
주현정|3|서울대학교 영어영문 대학원 석사||member
권성일|3|한양대학교 산업공학과|현대자동차|member
장재원|4|고려대학교 의료통계 대학원 석사|카카오헬스케어|member
이유림|4|동덕여자대학교 정보통계학과||member
김선지|4|성신여자대학교 통계학과|웰컴저축은행 디지털금융빅데이터분석팀|member
연다인|4|연세대학교 정보 대학원 석사|숙명여대 경영학과(13)|member
길지홍|4|인하대학교 경제학과|한국투자증권 디지털플랫폼본부|member
박세호|4|연세대학교 통계 대학원 석사|LG CNS|member
최수경|4|중앙대학교 광고홍보학과||member
홍정민|4|중앙대학교 중국어문학과/응용통계학과|리서치앤리서치 사회조사본부|member
이승은|5|강원대학교 경영학과||member
곽대훈|5|고려대학교 컴퓨터학과 대학원 석사||member
양우식|5|고려대학교 산업경영공학과 대학원 석사|NICE 평가정보|member
고가영|5|성신여자대학교 통계학과||member
김다혜|5|서울대학교 보건통계 대학원 석사||member
최도현|5|숭실대학교 정보통계보험수리학과|삼성전자 DS부문|member
정현재|5|아주대학교 e-Business학과|현대자동차|member
이제형|5|인하대학교 컴퓨터정보공학과||member
박이삭|5|인하대학교 통계학과|라인게임즈 데이터사이언스팀|member
이다경|5|인하대학교 통계학과|SK C&C|member
방정훈|5|중앙대학교 응용통계학과||member
이정민|5|한양대학교 경영학과||member
김은서|5|한양대학교 산업공학과||member
김지수|6|건국대학교 응용통계학과|SKT AI센터|vice_president
장재석|6|연세대학교 산업공학 대학원 석사|SK하이닉스|member
임진주|6|고려대학교 통계학과||member
구혜인|6|고려대학교 통계학과||member
조상원|6|동국대학교 경제학과||member
이혜주|6|성신여자대학교 통계학과||member
한동훈|6|연세대학교 경제학과|금융감독원|member
장정주|6|서울대학교 보건통계 대학원 석사||member
우경원|6|중앙대학교 경영학과||member
유누리|6|한양대학교 산업공학과|삼성 SDS|member
김서연|6|고려대학교 산업경영공학과 대학원 석사||member
전종섭|7|건국대학교 응용통계학과|데이터브릭스|member
박현진|7|고려대학교 컴퓨터학과 대학원 석사||member
이수빈|7|고려대학교 산업경영공학과 대학원 석사|삼성전자 DS부문|member
오건우|7|고려대학교 통계학과|현대해상|member
최희정|7|고려대학교 산업경영공학과 대학원 석/박사||member
이유리|7|인하대학교 통계 대학원 석사||member
이광록|7|KAIST 수리과학과|NAVER AiRS|member
이현경|8|건국대학교 응용통계학과||member
황다솔|8|고려대학교 컴퓨터학과 대학원 석사|LG AI Research|member
김강열|8|KAIST AI 대학원 석사||member
최서현|8|서울시립대학교 경영학과|토스 Data Analyst|member
조양규|8|서울시립대학교 통계학과|NAVER WEBTOON|member
김민정|8|숙명여대학교 통계학과|11번가 검색모델링팀|member
김소희|8|숙명여대학교 통계학과|SK C&C|member
김수현|8|고려대학교 컴퓨터학과 대학원 석사||member
이태권|8|Berlin Institute of Technology 컴퓨터과학 석사||member
류호성|8|인하대학교 통계 대학원 석사|LG CNS|member
이인재|8|인하대학교 통계학과||member
김은서|8|인하대학교 통계학과||member
최수정|8|중앙대학교 경영학부|농협은행 디지털|member
최재훈|8|중앙대학교 경제학부|NICE 평가정보|member
정인호|9|건국대학교 경영정보학과||member
전민규|9|고려대학교 컴퓨터학과 대학원 석사||member
유리안나|9|경희대학교 경영학과||member
이잉걸|9|고려대학교 컴퓨터학과 대학원 석사|LG CNS|member
서석현|9|고려대학교 통계학과|LG CNS|member
안상준|9|연세대학교 산업공학 대학원 석사|LG U+|member
김동규|9|AMIST 의공학과 박사과정|서울아산병원 의공학연구소 연구원|member
최영제|9|연세대학교 산업공학 대학원 석사|한국투자증권|member
김수지|9|덕성여자대학교 정보통계학과|PwC컨설팅 금융본부|member
신현경|9|연세대학교 전기전자공학 대학원 석사|NAVER Clova|member
신용재|9|서울과학기술대학교 경영학과|NH투자증권|member
김명진|9|연세대학교 컴퓨터공학 대학원 석사||member
박송은|9|숙명여자대학교 통계학과||member
임소정|9|숙명여자대학교 통계학과||member
백광제|9|고려대학교 컴퓨터학과 대학원 석사||member
이준걸|10|고려대학교 산업경영공학과 대학원 석사||president
박성진|10|고려대학교 컴퓨터학과 대학원 석사|NAVER GLACE CIC|member
박규리|10|경희대학교 경영학과||member
임진혁|10|국민대학교 빅데이터경영통계|포스코홀딩스 AI연구소|member
최세영|10|덕성여자대학교 컴퓨터공학과||member
장청아|10|동국대학교 식품산업관리학과||member
정윤호|10|서강대학교 철학과||member
황이은|10|서울시립대학교 경제학부|마이다스아이티|member
이민주|10|숙명여자대학교 통계학과|KAKAO|member
강인구|10|연세대학교 기계공학과|NCSOFT Vision AI Lab|member
신훈철|10|홍익대학교 산업공학과|마키나락스|member
이영전|11|가천대학교 소프트웨어학과 석사|캐치테이블 데이터 엔지니어|member
임채빈|11|고려대학교 인공지능학과 대학원 석사||member
심은선|11|건국대학교 응용통계학과||member
김대웅|11|동국대학교 컴퓨터공학과 석사|마키나락스|member
이소라|11|덕성여자대학교 정보통계학과|컬리 데이터분석|member
김유민|11|서울시립대학교 영어영문학과|SK C&C|member
이도연|11|숙명여자대학교 IT공학전공||member
정혜인|11|숙명여자대학교 컴퓨터과학전공||member
권혜민|11|이화여자대학교 컴퓨터공학과|현대모비스 주행영상인식셀|member
한재연|11|한양대 수학과||member
김효은|12|건국대학교 응용통계학과||member
김태욱|12|국민대학교 빅데이터경영통계|마키나락스|member
김주호|12|국민대학교 빅데이터경영통계|LINER|president
배유나|12|국민대학교 빅데이터경영통계|삼성 SDS|member
김수아|12|명지대학교 융합소프트웨어학부|NAVER 라이브커머스 개발|member
조민호|12|서강대학교 철학과|카카오 픽코마|member
윤기오|12|고려대학교 산업경영공학과 대학원 석/박사||member
이승현|12|University of Michigan 박사과정||member
김탁영|12|University of Illinois Urbana-Champaign 박사과정||vice_president
박진혁|12|성균관대학교 전자전기공학부||member
이홍정|12|성균관대학교 행정학과|LG CNS|member
이세윤|12|숙명여자대학교 통계학과||member
강민성|12|연세대학교 기계공학과 대학원 석사|현대자동차 엔지니어링 데이터 관련|member
김태한|12|KAIST AI대학원 석사||member
이유진|12|이화여자대학교 경영학과||member
신윤종|12|한신대학교 IT경영학과||member
이예진|13|건국대학교 인공지능학과 대학원 석사|LG AI Research|member
고유경|13|고려대학교 산업경영공학과 대학원 석사|SKT|member
정주원|13|고려대학교 철학과|LG CNS|member
오진석|13|국민대학교 경영정보학부|넥슨 인텔리전스랩스 데이터 분석|member
신민정|13|연세대학교 인공지능학과 대학원 석사||member
이지용|13|서강대학교 사회학과|데브시스터즈 데이터엔지니어|member
김미성|13|서울과학기술대학교 컴퓨터공학과|IBK 기업은행 디지털|member
이유민|13|서울시립대학교 통계학과|삼성전자 DS부문|member
이혜민|13|서울여자대학교 정보보호학과|SK 쉴더스 EQST 모의해킹|member
조상연|13|성균관대학교 미디어커뮤니케이션학과|NAVER 플레이스사용자&리뷰개발|member
강미경|13|성균관대학교 인공지능융합학과 석사||member
이예지|13|고려대학교 산업경영공학과 대학원 석사||member
이재빈|13|이화여자대학교 통계학과 대학원 석사|삼성전자 혁신센터|member
김민정|13|숙명여자대학교 통계학과||member
김현선|13|이화여자대학교 통계학과 대학원 석사|LG전자|president
최혜빈|13|이화여자대학교 휴먼기계바이오공학부||member
정민준|13|서울대학교 대학원 협동과정 인공지능전공 석사||member
조혜원|13|홍익대학교 동양화과||member
강재영|14|건국대학교 응용통계학과|엔라이즈 Product Data Analyst|vice_president
정재윤|14|고려대학교 산업경영공학부 대학원 석사||member
김민경|14|동덕여자대학교 정보통계학과||member
한유진|14|동덕여자대학교 정보통계학과||member
장예은|14|University of Michigan - Ann Arbor 데이터사이언스 석사||member
이원도|14|서울대학교 융합과학기술대학원 석사||member
박준영|14|서울시립대학교 경제학부||member
김상현|14|성균관대학교 전자전기컴퓨터공학과 대학원 석사||member
강의정|14|서울여자대학교 정보보호학과||member
박지은|14|고려대학교 산업경영공학부 대학원 석사|현대자동차 인포테인먼트개발센터|member
정세영|14|성신여자대학교 통계학과|코오롱베니트|member
이정은|14|세종대학교 데이터사이언스학과||member
장혜림|14|숙명여자대학교 빅데이터분석융합학과 대학원 석사|KT|member
이혜린|14|이화여자대학교 통계학과 대학원 석사|신한은행 데이터사이언티스트|president
서아라|14|KAIST 김재철AI대학원 석사||member
조효원|15|KAIST 김재철AI대학원 석사||member
김현지|15|고려대학교 산업경영공학과 대학원 석사|삼성전자 SAIT|member
김동현|15|국민대학교 경영정보학과|신한은행 데이터사이언티스트|member
권오현|15|국민대학교 빅데이터경영통계|카카오뱅크 데이터사이언티스트|member
오주영|15|국민대학교 빅데이터경영통계||member
안민준|15|동국대학교 경영학과|NCSOFT|member
이윤정|15|동국대학교 통계학과||member
강지우|15|동덕여자대학교 통계학과||member
황보진경|15|서울대학교 산업공학과||member
박진수|15|POSTECH 인공지능대학원 석사||member
김재희|15|서울대학교 산업공학과 박사||member
조준혁|15|세종대학교 통계학과||member
이수민|15|숭실대학교 산업정보시스템공학과|나이키코리아 데이터분석|president
김태희|15|이화여자대학교 휴먼기계바이오공학부||member
장아연|15|이화여자대학교 휴먼기계바이오공학부||member
이성범|15|한신대학교 IT경영학과||member
주지훈|16|건국대학교 응용통계학과|쿠팡 Program Manager|member
김주호|16|서울대학교 통계학과 대학원 석사||member
김윤혜|16|동덕여자대학교 정보통계학과||member
김종우|16|KAIST 산업공학과 박사||member
장준원|16|POSTECH 인공지능대학원 석사||president
박한나|16|숙명여자대학교 통계학과|KT|member
김송민|16|연세대학교 문헌정보학과||member
이예림|16|연세대학교 응용통계학과||vice_president
이승주|16|서울대학교 인공지능협동과정 박사과정||member
김권호|16|서울대학교 데이터사이언스학과||member
김경준|16|UNIST 인공지능대학원||member
전민진|16|POSTECH 인공지능대학원 석박통합||member
정수연|16|한양대학교 파이낸스경영학과|PwC컨설팅 FS본부|member
김건우|16|서울대학교 산업공학과 대학원 석사|김앤장 법률사무소 AI&IT System Center|member
김상윤|17|인하대학교 컴퓨터공학과||member
김정민|17|숙명여자대학교 일반대학원 Business Analytics 석사||member
김현태|17|중앙대학교 인공지능 대학원 석사||member
나세연|17|성균관대학교 수학과/전자전기공학부|삼성전자 메모리사업부 평가 및 분석|member
박나윤|17|인천대학교 산업경영공학과 대학원 석사||member
신은아|17|서울시립대학교 통계학과|CJ프레시웨이 데이터분석|member
염제윤|17|연세대학교 통계데이터사이언스학과||member
이예진|17|한양대학교 신소재공학부||member
유현우|17|중앙대학교 경영학과||member
이지수|17|연세대학교 산업공학과 대학원 석사||member
이혁종|17|서울대학교 의과학과 석박통합||member
임수진|17|서울과학기술대학교 산업공학과|NH농협은행|vice_president
장준보|17|중앙대학교 인공지능 대학원 석사|SK C&C|president
홍종현|17|국민대학교 빅데이터경영통계학과||member
강효은|18|이화여자대학교 통계학과||member
고나경|18|숙명여자대학교 통계학과||member
국주현|18|숙명여대 대학원 IT공학과 석사||member
권소영|18|UNIST 인공지능대학원 석사||member
김성우|18|한양대학교 산업공학과 대학원 석사|현대자동차 연구개발 AI팀 (24)|president
김성훈|18|서울시립대학교 통계학과||member
김정우|18|가천대학교 기계공학과||member
김희경|18|숙명여자대학교 통계학과||member
남주연|18|성균관대학원 통계학과 석사||member
류다윤|18|한양대학교 경영학부|KB국민은행 데이터|member
배유진|18|KAIST 로봇공학학제전공||member
손유진|18|가톨릭대학교 경영학과||member
이기정|18|국민대학교 전자공학과||member
이다인|18|세종대학교 환경에너지공간융합공학과||vice_president
이선민|18|이화여자대학교 환경공학과||member
이정우|18|성균관대학교 인공지능융합학과 석사||member
표솔빈|18|성균관대학교 데이터사이언스||member
현승현|18|중앙대학교 응용통계학과||member
권유진|19|국민대학교 AI빅데이터융합경영학과|CJ대한통운 TES물류기술연구소|member
김민서|19|서울시립대학교 컴퓨터과학부||member
김윤서|19|성균관대학교 경영학과/데이터사이언스융합학과||member
김은지|19|동국대학교 통계학과||member
김은호|19|숙명여자대학교 통계학과||member
오유진|19|이화여자대학교 통계학과||member
위성진|19|인천대학교 컴퓨터공학부||member
윤세휘|19|인천대학교 대학원 컴퓨터공학과||member
이동우|19|한양대학교 산업공학과||member
이동준|19|중앙대학교 AI 대학원 석사|Vuno research scientist 재직중|member
이영아|19|숙명여자대학교 일반대학원 IT공학과||member
이혁준|19|중앙대학교 건설환경플랜트공학과/소프트웨어학부||member
임서영|19|서울대학교 뇌인지과학과||member
임승섭|19|건국대학교 응용통계학과/컴퓨터공학과||member
임지영|19|카이스트 전기전자공학부 석사||president
조성민|19|수원대학교 데이터과학부||member
최경주|19|아주대학교 사이버보안학과||member
최다희|19|동국대학교 통계학과/융합소프트웨어|우리카드|member
최태순|19|서울시립대학교 통계학과|SK AX|member
표지원|19|한양대학교 컴퓨터소프트웨어학부||vice_president
하주찬|19|한양대학교 전기생체공학부 생체공학전공||member
한진모|19|서울대학교 교육학과/인공지능학과||member
강서현|20|성균관대학교 교육학과/컴퓨터교육과||member
경민수|20|서울시립대학교 컴퓨터과학부||vice_president
구자협|20|서울과학기술대학교 산업정보시스템전공||president
김은서|20|한양대학교 경영학부||member
김지우|20|한양대학교 도시공학과||member
도형준|20|한양대학교 경영학과/빅데이터융합학과||member
박수형|20|가톨릭대학교 데이터사이언스학과||member
박준|20|성균관대학교 데이터사이언스학과/소프트웨어학과||member
설유민|20|한양대학교 정보시스템학과||member
송인혁|20|KAIST 산업및시스템공학과 석사||member
양승빈|20|KAIST AI 대학원 석사||member
양지우|20|동국대학교 통계학과||member
오수아|20|성신여자대학교 수리통계데이터사이언스학부||member
이태범|20|고려대학교 인공지능학과 석사||member
임가연|20|숭실대학교 산업정보시스템공학과|삼성전자|member
전소연|20|숙명여자대학교 통계학과/컴퓨터과학과||member
정준호|20|한양대학교 대학원 산업공학과||member
조미현|20|고려대학교 산업경영공학부||member
조민영|20|숙명여자대학교 통계학과/소프트웨어융합전공||member
주세현|20|명지대학교 데이터테크놀리지학과||member
최태은|20|연세대학교 UIC 경제학/컴퓨터과학과||member
황민정|20|건국대학교 응용통계학과||member
황태연|20|서울대학교 지능정보융합학과 석박통합과정||member
공서연|21|고려대학교 식품자원경제학과/인공지능융합전공||member
김나현|21|이화여자대학교 휴먼기계바이오공학부||member
김민수|21|동국대학교 정보통신공학과/데이터사이언스전공||member
김세민|21|성균관대학교 인공지능융합전공|스퀴즈비츠|member
김솔빈|21|이화여자대학교 인공지능학과||member
김용진|21|고려대학교 인공지능학과 석박통합과정||vice_president
김인호|21|KENTECH 에너지 AI학과 대학원 석사||member
김지은|21|국민대학교 AI빅데이터융합경영학과||member
김창현|21|서울시립대학교 통계데이터사이언스학부 석사||member
박건우|21|경희대학교 산업경영공학과/소프트웨어융합학과||member
박민지|21|이화여자대학교 통계학과 석사||member
신기섭|21|국민대학교 AI빅데이터융합경영학과/소프트웨어융합전공||member
양재민|21|광운대 로봇학부 지능시스템전공|광운대 로봇학부 지능시스템전공 (19)|president
이소영|21|성균관대학교 통계학과||member
임형빈|21|국민대학교 AI빅데이터융합경영학과||member
조솔비|21|숙명여자대학교 컴퓨터과학전공||member
진혜정|21|고려대학교 통계학과 석사||member
지유경|21|성균관대학교 소프트웨어학과 석사과정||member
차민재|21|경희대학교 산업경영공학과||member
함양훈|21|강남대학교 데이터사이언스학과||member
강연주|22|서울과학기술대학교 산업정보시스템전공/인공지능응용학과||member
강현구|22|고려대학교 인공지능학과 석사과정||member
김근하|22|한양대학교 대학원 인공지능학과||member
김희망|22|서울대학교 사회학과/통계학과||member
박지원|22|이화여자대학교 컴퓨터공학과||president
방지현|22|성신여자대학교 바이오헬스서비스학과/빅데이터사이언스학과||member
송수현|22|경기대학교 산업경영공학과||vice_president
송진하|22|서울과학기술대학교 건축공학과||member
양가현|22|숙명여자대학교 통계학과/소프트웨어학부||member
염승희|22|이화여자대학교 인공지능학과||member
우단비|22|중앙대학교 응용통계학과||member
이강진|22|한양대학교 산업공학과/컴퓨터소프트웨어학부||member
이호|22|서울과학기술대학교 경영학과/산업공학과||member
장민지|22|이화여자대학교 지리교육전공/컴퓨터공학||member
정혜정|22|동덕여자대학교 정보통계학과/경제학과||member
정환길|22|인천대학교 컴퓨터공학과||member
조하늘|22|성신여자대학교 빅데이터사이언스학과||member
진민찬|22|서울과학기술대학교 전자IT미디어공학과/ICT인공지능||member
최수지|22|이화여자대학교 데이터사이언스학과||member
최해원|22|건국대학교 응용통계학과/컴퓨터공학부||member
한다은|22|서울과학기술대학교 산업정보시스템/핀테크AI경영||member
곽은진|23|숙명여자대학교 통계학과/소프트웨어융합학과||member
김민정|23|덕성여자대학교 디지털소프트웨어공학부||member
김상우|23|중앙대학교 건설환경플랜트공학/전기전자공학부||member
남재현|23|건국대학교 산업공학과||member
류윤걸|23|한양대학교 경제금융학부/산업공학과||member
문혜원|23|성신여자대학교 빅데이터사이언스전공/AI||member
서동혁|23|상명대학교 에너지그리드학과 석사과정||member
양민지|23|성신여자대학교 AI 융합학부||member
염승원|23|이화여자대학교 통계학과/컴퓨터공학과||member
이태인|23|이화여자대학교 전자전기공학전공||president
임규원|23|서울과학기술대학교 인공지능응용학과/지능형반도체공학과||member
임지혜|23|인하대학교 정보통신공학과||member
임채민|23|성균관대학교 데이터사이언스학부/경제학과||member
장가람|23|국민대학교 경영정보학부/AI빅데이터융합학과||member
정서영|23|아주대학교 소프트웨어학과||member
지민석|23|경희대학교 응용수학과/컴퓨터공학과||vice_president
조성화|23|한양대학교 데이터사이언스학부/전기공학과||member
하정민|23|서울시립대 국제관계학/빅데이터분석학||member
한다인|23|이화여자대학교 인공지능학과||member
한종민|23|건국대학교 산업공학과/응용통계학과||member
강수빈|24|숙명여자대학교 IT공학부/빅데이터||member
김동욱|24|홍익대학교 컴퓨터공학과||member
김승현|24|성신여자대학교 수리통계데이터사이언스/빅데이터사이언스||member
김준수|24|서울시립대학교 컴퓨터과학과/인공지능학과||vice_president
김지우|24|동덕여자대학교 정보통계학과/데이터사이언스학과||member
박승현|24|한양대학교 경영학부/컴퓨터소프트웨어학부||member
박현서|24|이화여자대학교 불어불문학과/통계학과||member
서민정|24|경희대학교 수학과/경제학과||member
원정선|24|숭실대학교 미디어경영학과/컴퓨터학부||member
윤정우|24|서강대학교 사학과/컴퓨터공학과||member
이상민|24|중앙대학교 응용통계학과/AI학과||member
이용선|24|서울과학기술대학교 인공지능응용학과||member
정서윤|24|이화여자대학교 컴퓨터공학과||member
정연우|24|서울시립대학교 통계학과||member
최혜윤|24|이화여자대학교 인공지능학과||president
한재희|24|이화여자대학교 통계학과||member
허지원|24|이화여자대학교 컴퓨터공학과||member
고민수|25|동국대학교 산업시스템공학과/융합소프트웨어학과||member
김가빈|25|덕성여자대학교 컴퓨터공학전공/정보통계학전공||member
김은경|25|덕성여자대학교 디지털소프트웨어공학부||member
김예나|25|이화여자대학교 수학교육과/통계학과/소프트웨어전공||member
김준영|25|한국외국어대학교 통계학과/컴퓨터공학과||president
김지윤|25|이화여자대학교 컴퓨터공학과||member
김지은|25|덕성여자대학교 디지털소프트웨어공학부||member
김태은|25|숙명여자대학교 경영학부/컴퓨터과학전공||member
김태희|25|이화여자대학교 데이터사이언스학과||member
나수경|25|가천대학교 금융수학과/컴퓨터공학과||member
남재은|25|이화여자대학교 데이터사이언스학과||member
박명훈|25|건국대학교 산업공학과||member
박연수|25|이화여자대학교 컴퓨터공학과||member
송화원|25|서울시립대학교 통계학과||member
유주형|25|고려대학교 바이오시스템의과학부/통계학과||member
이용혁|25|인하대학교 산업경영공학과||member
이유민|25|덕성여자대학교 경영학과/정보통계학과||member
이정연|25|세종대학교 데이터사이언스학과/경제학과||member
정상현|25|홍익대학교 컴퓨터공학과||member
조윤수|25|고려대학교 간호학과||member
조항준|25|경기대학교 컴퓨터공학전공||member
최강혁|25|건국대학교 산업공학과||vice_president
한수영|25|건국대학교 산업공학과||member
`;

export const membersMock: Member[] = rawData
  .trim()
  .split('\n')
  .map((line, idx) => {
    const [name, generationStr, university, company, role] = line.split('|');
    return {
      id: String(idx + 1),
      name,
      generation: parseInt(generationStr, 10),
      university: university || '',
      company: company || '',
      role: (role || 'member') as Member['role'],
      profile_image_url: null,
    };
  });